'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationLists = function (_Resource) {
    (0, _inherits3.default)(LocationLists, _Resource);

    function LocationLists() {
        (0, _classCallCheck3.default)(this, LocationLists);
        return (0, _possibleConstructorReturn3.default)(this, (LocationLists.__proto__ || (0, _getPrototypeOf2.default)(LocationLists)).apply(this, arguments));
    }

    (0, _createClass3.default)(LocationLists, [{
        key: 'delete',

        /**
         * @api {delete} /v1/organization_location_lists/:organization_location_list_id delete
         * @apiGroup LocationLists
         * @apiName delete
         * @apiDescription Delete the specified location list only if location list is associated with an active organizationSubscription. This is a soft delete.
         * @apiParam {Number} organization_location_list_id
         * @apiExample {js} Example:
         *             gigwalk.locationLists.delete({...})
         */
        value: function _delete(params) {
            return this.client.delete('/v1/organization_location_lists/' + params.organization_location_list_id);
        }

        /**
         * @api {get} /v1/organization_location_lists/:organization_location_list_id get
         * @apiGroup LocationLists
         * @apiName get
         * @apiDescription Get location list.
         * @apiParam {Number} organization_location_list_id
         * @apiExample {js} Example:
         *             gigwalk.locationLists.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            return this.client.get('/v1/organization_location_lists/' + params.organization_location_list_id);
        }

        /**
         * @api {put} /v1/organization_location_lists/:organization_location_list_id update
         * @apiGroup LocationLists
         * @apiName update
         * @apiDescription Modify location list. Updates can be done in three ways:
                           1. Specified in JSON format - ('name': location_list_name, 'status': ACTIVE/INACTIVE/ARCHIVE/DELETED, 'locations': array of locations).
                           2. Addresses can be uploaded from a csv file.
                           3. Location_ids can be uploaded from a spreadsheet.
         * @apiParam {Number} organization_location_list_id
         * @apiParam {Object} location_list
         * @apiExample {js} Example:
         *             gigwalk.locationLists.update({...})
         */

    }, {
        key: 'update',
        value: function update(params) {
            return this.client.put('/v1/organization_location_lists/' + params.organization_location_list_id, (0, _extends3.default)({}, params.location_list));
        }

        /**
         * @api {delete} /v1/organizations/:organization_id/location_lists deleteForOrganization
         * @apiGroup LocationLists
         * @apiName deleteForOrganization
         * @apiDescription Delete the specified location list only if location list is associated with an active organizationSubscription. This is a soft delete.
         * @apiParam {Number} organization_id
         * @apiParam {Number[]} location_list_ids
         * @apiExample {js} Example:
         *             gigwalk.locationLists.deleteForOrganization({...})
         */

    }, {
        key: 'deleteForOrganization',
        value: function deleteForOrganization(params) {
            var data = {
                location_list_ids: params.location_list_ids
            };

            return this.client.delete('/v1/organizations/' + params.organization_id + '/location_lists', data);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/location_lists getForOrganization
         * @apiGroup LocationLists
         * @apiName getForOrganization
         * @apiDescription Get all location lists that belong to the given organization. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.locationLists.getForOrganization({...})
         */

    }, {
        key: 'getForOrganization',
        value: function getForOrganization(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/organizations/' + params.organization_id + '/location_lists' + query);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/location_lists createForOrganization
         * @apiGroup LocationLists
         * @apiName createForOrganization
         * @apiDescription Create a location list for the organization. Creation can be done in three ways:
                           1. Specified in JSON format - ('name': location_list_name, 'status': ACTIVE/INACTIVE/ARCHIVE/DELETED, 'locations': array of locations).
                           2. Addresses can be uploaded from a csv file.
                           3. Location_ids can be uploaded from a spreadsheet.
         * @apiParam {Number} organization_id
         * @apiParam {Object} location_list
         * @apiExample {js} Example:
         *             gigwalk.locationLists.createForOrganization({...})
         */

    }, {
        key: 'createForOrganization',
        value: function createForOrganization(params) {
            return this.client.post('/v1/organizations/' + params.organization_id + '/location_lists', (0, _extends3.default)({}, params.location_list));
        }

        /**
         * @api {delete} /v1/organization_location_lists/:organization_location_list_id/locations/:location_id deleteLocationForOrganization
         * @apiGroup LocationLists
         * @apiName deleteLocationForOrganization
         * @apiDescription Delete location from the specified location list. The location is removed from the location list.
         * @apiParam {Number} organization_location_list_id
         * @apiParam {Number} location_id
         * @apiExample {js} Example:
         *             gigwalk.locationLists.deleteForOrganization({...})
         */

    }, {
        key: 'deleteLocationForOrganization',
        value: function deleteLocationForOrganization(params) {
            return this.client.delete('/v1/organization_location_lists/' + params.organization_location_list_id + '/locations/' + params.location_id);
        }

        /**
         * @api {delete} /v1/location_lists/:organization_location_list_id/locations/:location_id deleteLocation
         * @apiGroup LocationLists
         * @apiName deleteLocation
         * @apiDescription Delete location from the specified location list. The location is removed from the location list.
         * @apiParam {Number} organization_location_list_id
         * @apiParam {Number} location_id
         * @apiExample {js} Example:
         *             gigwalk.locationLists.deleteLocation({...})
         */

    }, {
        key: 'deleteLocation',
        value: function deleteLocation(params) {
            return this.client.delete('/v1/location_lists/' + params.organization_location_list_id + '/locations/' + params.location_id);
        }

        /**
         * @api {get} /v1/location_lists/:organization_location_list_id/locations getLocations
         * @apiGroup LocationLists
         * @apiName getLocations
         * @apiDescription Get all locations of the given location list. Capable of returning paginated results.
         * @apiParam {Number} organization_location_list_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.locationLists.getLocations({...})
         */

    }, {
        key: 'getLocations',
        value: function getLocations(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/location_lists/' + params.organization_location_list_id + '/locations' + query);
        }

        /**
         * @api {post} /v1/location_lists/:organization_location_list_id/locations addLocations
         * @apiGroup LocationLists
         * @apiName addLocations
         * @apiDescription Add location ids specified in JSON payload to location list.
         * @apiParam {Number} organization_location_list_id
         * @apiParam {Number[]} locations
         * @apiExample {js} Example:
         *             gigwalk.locationLists.addLocations({...})
         */

    }, {
        key: 'addLocations',
        value: function addLocations(params) {
            var data = params.locations.map(function (id) {
                return { id: id };
            });
            return this.client.post('/v1/location_lists/' + params.organization_location_list_id + '/locations', data);
        }

        /**
         * @api {put} /v1/location_lists/:organization_location_list_id/locations removeLocations
         * @apiGroup LocationLists
         * @apiName removeLocations
         * @apiDescription Remove location ids specified in JSON payload from location list.
         * @apiParam {Number} organization_location_list_id
         * @apiParam {Number[]} locations
         * @apiParam {Number[]} relations
         * @apiExample {js} Example:
         *             gigwalk.locationLists.removeLocations({...})
         */

    }, {
        key: 'removeLocations',
        value: function removeLocations(params) {
            var data = {};
            data.action = 'remove';

            if (params.locations) {
                data.locations = params.locations;
            } else {
                data.relations = params.relations;
            }

            return this.client.put('/v1/location_lists/' + params.organization_location_list_id + '/locations', data);
        }

        /**
         * @api {post} /v1/location_lists/:organization_location_list_id/search/locations searchList
         * @apiGroup LocationLists
         * @apiName searchList
         * @apiDescription Search locations in a location list. Can search for in title, address, administrative area level 1/2 or country
         * @apiParam {Number} organization_location_list_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.locationLists.searchList({...})
         */

    }, {
        key: 'searchList',
        value: function searchList(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.post('/v1/location_lists/' + params.organization_location_list_id + '/search/locations' + query);
        }

        /**
         * @api {get} /v1/location_lists/:location_list_id/upload getFileInfo
         * @apiGroup LocationLists
         * @apiName getFileInfoForLocationList
         * @apiDescription Get information about the file that was used to upload the location list.
         * @apiParam {Number} location_list_id
         * @apiExample {js} Example:
         *             gigwalk.locationLists.getFileInfo({...})
         */

    }, {
        key: 'getFileInfo',
        value: function getFileInfo(params) {
            return this.client.get('/v1/location_lists/' + params.location_list_id + '/upload');
        }

        /**
         * @api {get} /v1/organizations/:organization_id/location_lists/:location_list_id/upload getFileInfoForOrganization
         * @apiGroup LocationLists
         * @apiName getFileInfoForOrganizationLocationList
         * @apiDescription Get information about the file that was used to upload the location list.
         * @apiParam {Number} organization_id
         * @apiParam {Number} location_list_id
         * @apiExample {js} Example:
         *             gigwalk.locationLists.getFileInfoForOrganization({...})
         */

    }, {
        key: 'getFileInfoForOrganization',
        value: function getFileInfoForOrganization(params) {
            return this.client.get('/v1/organizations/' + params.organization_id + '/location_lists/' + params.location_list_id + '/upload');
        }

        /**
         * @api {post} /v1/organizations/:organization_id/location_lists/upload createForOrganizationWithFile
         * @apiGroup LocationLists
         * @apiName createOrganizationLocationListUsingFile
         * @apiDescription Create location list using an Amazon s3 uploaded file.
         * @apiParam {Number} organization_id
         * @apiParam {String} location_list_name
         * @apiParam {String[]} s3_keys
         * @apiExample {js} Example:
         *             gigwalk.locationLists.createForOrganizationWithFile({...})
         */

    }, {
        key: 'createForOrganizationWithFile',
        value: function createForOrganizationWithFile(params) {
            var data = {
                location_list_name: params.location_list_name,
                keys: params.s3_keys
            };

            return this.client.post('/v1/organizations/' + params.organization_id + '/location_lists/upload', data);
        }

        /**
         * @api {get} /v1/location_lists/:location_list_id/upload/:file_upload_id/unresolved_locations getUnresolved
         * @apiGroup LocationLists
         * @apiName getUnresolved
         * @apiDescription Update location address. Either a JSON payloa or file upload may be used as input.
         * @apiParam {Number} file_upload_id
         * @apiParam {Number} location_list_id
         * @apiExample {js} Example:
         *             gigwalk.locationLists.getUnresolved({...})
         */

    }, {
        key: 'getUnresolved',
        value: function getUnresolved(params) {
            return this.client.get('/v1/location_lists/' + params.location_list_id + '/upload/' + params.file_upload_id + '/unresolved_locations');
        }

        /**
         * @api {put} /v1/location_lists/:location_list_id/upload/:file_upload_id/unresolved_locations/:location_id updateAddress
         * @apiGroup LocationLists
         * @apiName updateAddress
         * @apiDescription Update location address. Either a JSON payload or file upload may be used as input.
         * @apiParam {Number} file_upload_id
         * @apiParam {Number} location_list_id
         * @apiParam {Number} location_id
         * @apiParam {Number} [csv]
         * @apiParam {String} [key]
         * @apiParam {Object[]} [location_data_array]
         * @apiExample {js} Example:
         *             gigwalk.locationLists.updateAddress({...})
         */

    }, {
        key: 'updateAddress',
        value: function updateAddress(params) {
            var data = {
                csv: params.csv ? params.csv : null,
                key: params.key ? params.key : null,
                location_data_array: params.location_data_array ? params.location_data_array : []
            };

            return this.client.put('/v1/location_lists/' + params.location_list_id + '/upload/' + params.file_upload_id + '/unresolved_locations/' + params.location_id, data);
        }
    }]);
    return LocationLists;
}(_resource2.default);

exports.default = LocationLists;
//# sourceMappingURL=index.js.map